/** Correct copying is practice, not evidence of independent recall. */
export function independentRecall(input, correct) {
    return correct && input.mode === "dictation" && input.hintUsed === false
        && input.errorCount === 0;
}
export function observedPracticeMinutes(duration) {
    return typeof duration === "number" && Number.isFinite(duration)
        ? Math.min(600_000, Math.max(0, duration)) / 60_000 : 0;
}
const words = (value) => value.toLowerCase().replace(/[‘’]/g, "'")
    .replace(/[‐‑‒–—−－]/g, "-").match(/[a-z0-9]+(?:['-][a-z0-9]+)*/g) || [];
/** Never manufacture subject/predicate labels from token positions. */
export function safeSentenceStructure(sentence) {
    const parts = (sentence.structure || []).filter((part) => part.text?.trim());
    const labels = parts.map((part) => part.label.trim()).join("/");
    const placeholder = labels === "主语/谓语/补充" || labels === "主语/核心词";
    const complete = words(parts.map((part) => part.text).join(" ")).join(" ") === words(sentence.english).join(" ");
    if (parts.length && !placeholder && complete)
        return parts;
    return [{ label: "整句阅读", text: sentence.english, explain: "本句结构标注尚待校审，暂不展示推测的语法成分。" }];
}
